import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ie-banner',
  templateUrl: './ie-banner.component.html',
  styleUrls: ['./ie-banner.component.sass']
})
export class IEBannerComponent {


  

}
